export const DEVELOPER_ROLE = { role: "DEV", roleName: "Developer" };

export const CSR_ROLE = {
  role: "CSR",
  roleName: "Customer Service Representative",
};
